if (!customElements.get('product-pendants')) {
  class ProductPendants extends HTMLElement {
    constructor() {
      super();

      this.mainProductId = '';
      this.mainTitle = this.dataset.title;
      this.cartDrawer = document.querySelector('cart-drawer');
      this.submitPend = this.querySelector('.product__submit--pendants');
      this.pendantInputs = this.querySelectorAll('input[type="radio"]');
      this.quantityInpit = document.querySelector('input[name="quantity"]');
      this.pendantTitle = null;
      this.pendantId = null;
      this.quantity = null;
    }

    connectedCallback() {
      this.submitPend.addEventListener('click', (event) => {
        event.preventDefault();

        this.submitHandler()
      });
    }

    submitHandler() {
      const selectedPendant = this.querySelector('input[type="radio"]:checked');
      this.pendantId = selectedPendant ? selectedPendant.dataset.id : '';
      this.pendantTitle = selectedPendant ? selectedPendant.dataset.title : '';
      this.mainProductId = this.dataset.mainId;

      this.addMainProductWithPendant(
          this.mainProductId,
          this.pendantId,
          this.pendantTitle,
          this.mainTitle,
          this.cartDrawer
            .getSectionsToRender()
            .map(section => section.section)
        )
        .then(response => {
          if (response.status) {
            console.error('Error adding to cart:', response.description);
          } else {
            this.cartDrawer.renderContents(response);
          }
        })
        .catch(error => {
          console.error(error);
        });
    }

    addMainProductWithPendant = (mainProductId, pendantId, pendantTitle, mainProductTitle, sections) => {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();

      this.quantity = this.quantityInpit ? this.quantityInpit.value : 1;

      if (pendantId) {
        formData.append('items[1][id]', pendantId);
        formData.append('items[1][quantity]', this.quantity);
        formData.append('items[1][properties][Pendant for]', mainProductTitle);
      };

      formData.append('items[0][id]', mainProductId);
      formData.append('items[0][quantity]', this.quantity);

      if (sections) {
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      return new Promise((resolve, reject) => {
        fetch(`${routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    };
  }
  customElements.define('product-pendants', ProductPendants);
}


// Dropdown code

const pendantContainer = document.querySelector('product-pendants');
const activePendant = document.querySelector('.active-pendant-dropdown');

activePendant.addEventListener("click", function (event) {
  pendantContainer.classList.toggle("open-pendants");
});

document.querySelectorAll('product-pendants input[type="radio"]').forEach(input => {
  input.addEventListener('change', () => {
    if (input.checked) {
      const label = input.nextElementSibling;
      const clonedLabel = label.cloneNode(true); // Deep clone
      
      const active = document.querySelector('product-pendants .active-pendant-dropdown');
      active.innerHTML = ''; // Clear previous content
      active.appendChild(clonedLabel);
      pendantContainer.classList.remove("open-pendants");
    }
  });
});
